// extracted by mini-css-extract-plugin
export default {"card":"zY-z","carouselContainer":"AY-z","carouselContent":"BY-z"};